module.exports = __webpack_public_path__ + "img/envianos-un-whatsapp.447633b9.png";